<template>
    <el-row :gutter="20" style="display: flex; align-items: center;">
        <el-col :span="8" class="filter-layout-text-left">
            <h2>ตารางเรียกรถเข้ารับ</h2>
        </el-col>
        <el-col :span="16" class="filter-booking-calendar-layout-text">
            <el-row style="display: flex; align-items: center;">
                <el-col :span="5">
                    <el-checkbox v-model="bookingCalendar.someShop" size="medium" @change="clearSearchInput(bookingCalendar.someShop)">แสดงแค่บางร้าน</el-checkbox>
                </el-col>
                &nbsp;&nbsp;
                <el-col :span="6">
                    <el-select
                        v-model="bookingCalendarSearch"
                        filterable
                        placeholder="ค้นหา"
                        remote
                        clearable
                        reserve-keyword
                        :loading="loading"
                        :disabled="!bookingCalendar.someShop"
                        :remote-method="remoteSearch"
                        @change="handleSelect"
                    >
                        <el-option-group
                            v-for="group in options"
                            :key="group.label"
                        >
                        <el-option
                            v-for="item in group.options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                        </el-option-group>
                    </el-select>
                </el-col>
                <el-col :span="2">
                    <el-button color="white" icon="el-icon-arrow-left" @click="prevCalendar"></el-button>
                </el-col>
                &nbsp;
                <el-col :span="6" style="display: flex; padding-top: 10px;">
                    <el-date-picker
                        v-model="bookingCalendar.curruntDate"
                        ref="bookingCalendarDatePicker"
                        style="opacity: 0; height: 1px; width: 1px; padding-top: 50px;"
                        type="month"
                        placeholder="Pick a month"
                        @change="pickBookingDate()">
                    </el-date-picker>
                    <el-button style="width:100%; min-height: 41px; max-height: 41px;" color="white" @click="selectBookingDate()">{{bookingCalendar.text}}</el-button>
                </el-col>
                &nbsp;
                <el-col :span="2" style="display: flex;">
                    <el-button color="white" icon="el-icon-arrow-right" @click="nextCalendar"></el-button>
                </el-col>
                <el-col :span="3">
                    <el-button color="white" @click="todayCalendar()">Today</el-button>
                </el-col>
            </el-row>
        </el-col>
    </el-row>
</template>

<script>
import fgApi from '@/services/fillgoods'
import { sync, call } from 'vuex-pathify'
import 'dayjs/locale/th'

export default {
    name: 'BookingCalendarFilter',
    data () {
        return {
            options: [],
            loading: false,
            bookingCalendar: {
                curruntDate: '',
                someShop: false,
                text: ''
            }
        }
    },
    computed: {
        ...sync('booking/*')
    },
    created () {
        this.bookingCalendar.curruntDate = this.$dayjs(new Date())
        this.bookingCalendarObj.date.month = this.$dayjs(new Date(this.bookingCalendar.curruntDate)).format('MM')
        this.bookingCalendarObj.date.year = this.$dayjs(new Date(this.bookingCalendar.curruntDate)).format('YYYY')
    },
    watch: {
        'bookingCalendarObj.date': {
            deep: true,
            immediate: true,
            handler (date) {
                let newDate = `${date.year} ${date.month}`
                this.bookingCalendarDateFilter(newDate)
            }
        }
    },
    methods: {
        ...call('booking/*'),
        selectBookingDate () {
            this.$refs.bookingCalendarDatePicker.focus()
        },
        bookingCalendarDateFilter (date) {
            this.bookingCalendar.text = this.$dayjs(new Date(date)).locale('th').format('MMMM YYYY')
        },
        async pickBookingDate () {
            this.bookingCalendarObj.loading = true
            this.bookingCalendarObj.date.month = this.$dayjs(new Date(this.bookingCalendar.curruntDate)).format('MM')
            this.bookingCalendarObj.date.year = this.$dayjs(new Date(this.bookingCalendar.curruntDate)).format('YYYY')
            await this.gotoDateCalendar()
            this.bookingCalendarObj.loading = false
        },
        async clearSearchInput (show) {
            this.bookingCalendarObj.loading = true
            this.bookingCalendarSearch = show ? this.bookingCalendarSearch : null
            await this.fetchCalendarEventInfo()
            this.bookingCalendarObj.loading = false
        },
        async remoteSearch (query) {
            this.loading = true
            this.options = []
            this.timeoutSearch = setTimeout(async () => {
                let param = {
                    search: query
                }
                try {
                    let res = await fgApi.user.searchUserAndShop(param)
                    if (res.success) {
                        let searchResult = []
                        res.data.forEach(e => {
                            let shopList = this.setSearchOption(e.shops, e.user_code)
                            searchResult.push({
                                label: e.user_code,
                                options: shopList
                            })
                        })
                        this.options = searchResult
                    }
                } catch (error) {
                    this.$message.error(`Oops, Api is ${error} !`)
                }
                this.loading = false
            }, 500)
        },
        setSearchOption (dataArr, userCode) {
            let searchOptionArr = []
            searchOptionArr.push({
                value: userCode,
                label: userCode
            })
            for (let index in dataArr) {
                searchOptionArr.push({
                    value: dataArr[index].shop_id,
                    label: `${dataArr[index].shop_name}`
                })
            }
            return searchOptionArr
        },
        async handleSelect (item) {
            this.bookingCalendarObj.loading = true
            this.bookingCalendarSearch = item
            await this.fetchCalendarEventInfo()
            this.bookingCalendarObj.loading = false
        }
    }
}
</script>

<style lang="scss">
    .el-picker-panel .el-date-picker .el-popper{
        z-index: 2011;
        position: absolute;
        top: 125px;
        left: 918px;
    }
    .filter-booking-calendar-layout-text{
        text-align: end;
        .confirm-btn-style{
            background: #08A7A3;
            color: white;
        }
  }
</style>
<style scoped>
    ul li:first-child {
    color: #08A7A3;
    font-weight: bold;
    }
</style>
